import { useEffect, useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'

export function useCurrentUserName() {
  const { user } = useAuth()
  const [name, setName] = useState<string | null>(null)

  useEffect(() => {
    if (typeof user?.user_metadata?.full_name === 'string') {
      setName(user.user_metadata.full_name)
    } else if (typeof user?.user_metadata?.name === 'string') {
      setName(user.user_metadata.name)
    } else if (typeof user?.email === 'string') {
      setName(user.email.split('@')[0])
    } else {
      setName(null)
    }
  }, [user])

  return name
} 